import React from "react";
import { Clock, Users, Briefcase } from "lucide-react";
import { InsightsWave } from "@/assets/features/dashboard";

const INSIGHT_CARDS = [
  {
    label: "Total Candidates Managed",
    value: "156",
    sub: "Currently Hiring",
    subColor: "#076698",
    iconBg: "#EDE9FE",
    iconColor: "#7C3AED",
    Icon: Users,
  },
  {
    label: "Total Active Jobs",
    value: "8",
    sub: "All Positions",
    subColor: "#16A34A",
    iconBg: "#DCFCE7",
    iconColor: "#16A34A",
    Icon: Briefcase,
  },
  {
    label: "Average Time - To - Hire",
    value: "28",
    sub: "Days",
    subColor: "#D97706",
    iconBg: "#FEF3C7",
    iconColor: "#D97706",
    Icon: Clock,
  },
];

const DashboardInsightsPanel = () => (
  <div className="py-2">
    <div className="flex items-start justify-between gap-4 mb-5">
      <p className="text-xs text-secondary-foreground leading-relaxed max-w-[55%]">
        Leading Technology Company Focused On AI And Machine Learning Solutions. Strong Growth
        Trajectory With Plans To Expand Engineering Team
      </p>
      <InsightsWave className="shrink-0" />
    </div>
    <p className="text-sm font-semibold text-foreground mb-3">Top Trends insights</p>
    <div className="grid grid-cols-3 gap-3">
      {INSIGHT_CARDS.map((item) => (
        <div key={item.label} className="flex flex-col gap-1.5 p-3 rounded-xl border border-[#F0F0F0]">
          <div className="flex items-center gap-2">
            <div
              className="flex items-center justify-center rounded-lg p-1.5 w-7 h-7"
              style={{ background: item.iconBg }}
            >
              <item.Icon size={14} style={{ color: item.iconColor }} />
            </div>
            <p className="text-xs text-secondary-foreground leading-tight">{item.label}</p>
          </div>
          <p className="text-2xl font-bold text-foreground">{item.value}</p>
          <p className="text-xs font-medium" style={{ color: item.subColor }}>{item.sub}</p>
        </div>
      ))}
    </div>
  </div>
);

export default DashboardInsightsPanel;
